import React, { useEffect, useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog'
import { Button } from '../ui/button'
import { useAuth } from '@/hooks/getAuth'
import { EFreeTrialStatusType } from '../welcome-modal/welcome-modal'
import TrialDowngradeModal from './trial-expired-downgrade-modal'
import TrialPlansModal from './trial-plans-modal'
import { isBefore } from 'date-fns'

// Dialog for basic user first active free-trial
export default function TrialExpiredModal() {
  const [isOpen, setIsOpen] = useState(false)
  const [isOpenDowngrade, setIsOpenDowngrade] = useState(false)
  const [isOpenTrialPlans, setIsOpenTrialPlans] = useState(false)
  const [applyDiscount, setApplyDiscount] = useState(false)
  const { auth } = useAuth()

  useEffect(() => {
    const isExpired =
      auth?.trial_status === EFreeTrialStatusType.EXPIRED_TRIAL ||
      (auth?.trial_end_at && isBefore(new Date(auth.trial_end_at), new Date()))

    if (isExpired) {
      setIsOpen(true)
    } else {
      setIsOpen(false)
      setIsOpenDowngrade(false)
    }
  }, [auth])

  const handleDowngrade = () => setIsOpenDowngrade(true)

  const handleViewPlans = () => setIsOpenTrialPlans(true)

  return (
    <>
      <Dialog open={isOpen}>
        <DialogContent className="max-w-[440px] !p-8 rounded-lg">
          <DialogHeader>
            <DialogTitle className="md:text-2xl">
              Time to choose a Plan
            </DialogTitle>
          </DialogHeader>
          <div>
            <p>
              Your 3 Day Free Trial has ended. To continue accessing
              California’s best water rights and land use data, please select a
              plan.
            </p>
          </div>
          <DialogFooter className="flex sm:flex-col gap-4">
            <Button
              className="h-14 w-full text-lg "
              onClick={() => {
                setApplyDiscount(false)
                handleViewPlans()
              }}
            >
              View Plans
            </Button>
            <Button
              variant={'ghost'}
              className="!py-0 !h-fit text-sm font-normal"
              onClick={handleDowngrade}
            >
              No thanks. Downgrade me to Basic.
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
      <TrialDowngradeModal
        isOpen={isOpenDowngrade}
        onOpenChange={setIsOpenDowngrade}
        handleViewPlans={() => {
          setApplyDiscount(true)
          handleViewPlans()
        }}
      />
      <TrialPlansModal
        isOpen={isOpenTrialPlans}
        isDiscount={applyDiscount}
        onOpenChange={setIsOpenTrialPlans}
      />
    </>
  )
}
